// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pq7XothNf5mXudQ8WUN6kw\\=\\={font-size:20px;font-weight:500;line-height:24px}html[dir=ltr] .axM1HSepBsr9pNwkb8-44A\\=\\={margin-left:16px!important;margin-right:24px!important}html[dir=rtl] .axM1HSepBsr9pNwkb8-44A\\=\\={margin-right:16px!important;margin-left:24px!important}.axM1HSepBsr9pNwkb8-44A\\=\\=:active{opacity:.5}._2ElxuwEuW1gMozFzq6V7CA\\=\\={position:fixed;width:100%;top:0;z-index:1}html[dir] ._2ElxuwEuW1gMozFzq6V7CA\\=\\=.I3r8J9sBwEdX\\+FQvG3ZhIg\\=\\={-webkit-box-shadow:none;box-shadow:none}html[dir] .umW5dY5KRGjRHiF9gxxzrQ\\=\\=.Zdj6cCh5LNp1LT5tmn4Z8A\\=\\={background:var(--headerButtonPressedBackground,#0060aa);border-radius:4px}", ""]);
// Exports
exports.locals = {
	"primaryTitle": "pq7XothNf5mXudQ8WUN6kw==",
	"userPersona": "axM1HSepBsr9pNwkb8-44A==",
	"mailSurfaceHeader": "_2ElxuwEuW1gMozFzq6V7CA==",
	"hasSecondaryHeader": "I3r8J9sBwEdX+FQvG3ZhIg==",
	"icon": "umW5dY5KRGjRHiF9gxxzrQ==",
	"isButtonPressed": "Zdj6cCh5LNp1LT5tmn4Z8A=="
};
module.exports = exports;
